<script>
    import { createEventDispatcher } from 'svelte';
	import { DateInput } from 'date-picker-svelte'
    import { POCKETBASE_URL } from '../config';
    import Permisos from './CRUDPermiso.svelte'; // Importamos el componente
    import Atributos from './CrudAtributo.svelte'; // Importamos el componente
    import Impuestos from './CrudImpuesto.svelte'; // Importamos el componente

    export let newEntity; // Usar "entity" en lugar de "banco" para hacer reutilizable
    export let currentEntityId;
    export let isPaneOpen;
    export let togglePane;
    export let saveEntityEntry; // Función de guardado también genérica
    export let entityName = "Entidad"; // Nombre genérico de la entidad (se puede sobrescribir)
    export let editColumns;
    export let canCreate = false; // Nueva prop para crear
    export let canModify = false; // Nueva prop para modificar
    export let title = "Gestión de Entidades"; // Título genérico

    let permisos = []; // Nueva prop para gestionar permisos

    let activeTab = 'detalle';
    let errors = { nombre: '' }; // Validar el campo "nombre" genérico

    let isPreviewReady = true;

    const dispatch = createEventDispatcher();

    $: if (!isPaneOpen) {
        activeTab = 'detalle';
        resetErrors(); // Restablece errores al cerrar el panel
    }

    $: if (newEntity) {
        formatEntity(editColumns); // Formatea la entidad solo cuando está disponible
    }

    function handleInput() {
        dispatch('inputChange');
    }

    function resetErrors() {
        errors = { nombre: '' }; // Reinicia errores
    }

    function validateFields() {
        let valid = true;

        editColumns.forEach(col => {
            if (col.createOnly && currentEntityId) {
                return;
            }

            const value = newEntity[col.key]; // Obtiene el valor del nuevo entidad

            // Validar campos requeridos
            if (col.required) {
                if (col.type === 'text' || !col.type) {
                    // Verifica si el campo de texto está vacío
                    if (!value?.trim()) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si no está vacío
                    }
                } else if (col.type === 'number') {
                    // Verifica si el campo numérico es válido
                    if (value === undefined || value === null || isNaN(value)) {
                        errors[col.key] = `${col.label} debe ser un número válido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si es válido
                    }
                } else if (col.type === 'select') {
                    // Verifica si el campo de selección tiene un valor
                    if (!value) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si hay un valor
                    }
                } else if (col.type === 'date') {
                    if (!value || isNaN(new Date(value).getTime())) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = '';
                    }
                } else if (col.type === 'checkbox') {
                    // Verifica si el campo de selección tiene un valor
                    if (value === undefined) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si hay un valor
                    }
                } else if (col.type === 'email') {
                    // Verifica si el campo de texto es un correo electrónico válido
                    if (!value || !value.includes('@')) {
                        errors[col.key] = `${col.label} debe ser un correo electrónico válido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si es válido
                    }
                } else if (col.type === 'password') {
                    if (!value?.trim()) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else if (col.key === 'password' && value.trim().length < 8) {
                        errors[col.key] = `${col.label} debe tener al menos 8 caracteres.`;
                        valid = false;
                    } else if (col.key === 'passwordConfirm' && value !== newEntity.password) {
                        errors[col.key] = 'Las contraseñas no coinciden.';
                        valid = false;
                    } else {
                        errors[col.key] = '';
                    }
                } else if (col.type === 'file') {
                    // Verifica si el campo de archivo tiene un valor
                    if (!value) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si hay un valor
                    }
                } else if (col.type === 'json') {
                    // Verifica si el campo JSON tiene un valor
                    if (!value) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si hay un valor
                    }
                } else if (col.type === 'bool') {
                    // Verifica si el campo booleano tiene un valor
                    if (value === undefined) {
                        errors[col.key] = `${col.label} es requerido.`;
                        valid = false;
                    } else {
                        errors[col.key] = ''; // Reinicia el error si hay un valor
                    }
                } else if (col.type === 'hidden') {
                    // No se valida el campo oculto
                    errors[col.key] = '';
                } else {
                    console.warn(`Tipo de campo no manejado: ${col.type}`);
                }
            }
        });

        return valid; // Retorna el estado de validez
    }

    function handleSave() {
        if (validateFields()) {
            saveEntityEntry(); // Llama la función de guardado si pasa la validación
            isPreviewReady = true;
        }
    }

    // Revisión de fechas antes de montar
    function formatEntity(editColumns) {
        editColumns.forEach(col => {
            if (col.type === 'date') {
                if (newEntity[col.key] && typeof newEntity[col.key] === 'string') {
                    newEntity[col.key] = new Date(newEntity[col.key]);  // Asegura que sea un objeto Date
                }
            }
        });
    }

    // Manejar el cambio de archivo
    function handleFileUpload(event, key) {
        isPreviewReady = false;
        const file = event.target.files[0]; // Capturar el archivo
        if (file) {
            newEntity[key] = file;
        }
    }
</script>

{#if isPaneOpen}
    <div class="pane open flex flex-col h-full"> <!-- Ensure it takes full height -->
      <div
        class="p-4 top-0 right-0 bg-white shadow-xl text-base z-50 py-6 px-8 rounded-l-lg min-w-72 h-full overflow-y-auto transform transition-transform duration-300 ease-in-out translate-x-full"
      >
          <button class="absolute top-3 right-3 text-gray-600 hover:text-red-600 transition" on:click={togglePane}>
              <i class="fas fa-times"></i>
          </button>
          <br>
          <h2 class="text-xl font-bold">{currentEntityId ? `Editar ${title}` : `Crear ${title}`}</h2>
            <!-- Pestañas -->
            <div class="flex justify-end space-x-4 mb-4">
                <button on:click={() => (activeTab = 'detalle')} class="px-4 py-2 border-b-2" class:font-bold={activeTab === 'detalle'}>
                    Detalle
                </button>
                {#if newEntity['atributos']}
                    <button 
                        on:click={() => (activeTab = 'atributos')} 
                        class="px-4 py-2 border-b-2 {activeTab === 'atributos' ? 'font-bold' : ''}">
                        Atributos
                    </button>
                {/if}
                {#if newEntity['impuestos']}
                    <button 
                        on:click={() => (activeTab = 'impuestos')} 
                        class="px-4 py-2 border-b-2 {activeTab === 'impuestos' ? 'font-bold' : ''}">
                        Impuestos
                    </button>
                {/if}
            </div>
            <!-- Contenido de Detalle -->
            <div class="grid grid-cols-1 gap-6 max-h-60 overflow-y-auto">
                <div class="grid grid-cols-2 gap-6 max-h-60 overflow-y-auto">
                    {#if activeTab === 'detalle'}
                        {#each editColumns as column}
                            {#if column.createOnly && currentEntityId}
                                <!-- solo al crear -->
                            {:else if column.type === "hidden"}
                                <input 
                                    type="hidden" 
                                    bind:value={newEntity[column.key]} 
                                    on:input={handleInput} 
                                    disabled={!canModify && (!canCreate && currentEntityId) }
                                />
                            {:else}
                                <div class="space-y-2">
                                    <label for={column.key} class="block text-sm">{column.label}</label>

                                    {#if column.type === 'text'}
                                        <input
                                            type="text"
                                            placeholder={column.label}
                                            bind:value={newEntity[column.key]}
                                            on:input={handleInput}
                                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                            disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                    {/if}

                                    {#if column.type === 'email'}
                                    <input
                                        type="email"
                                        placeholder={column.label}
                                        bind:value={newEntity[column.key]}
                                        on:input={handleInput}
                                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                        disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                    {/if}

                                    {#if column.type === 'password'}
                                    <input
                                        type="password"
                                        placeholder={column.label}
                                        bind:value={newEntity[column.key]}
                                        on:input={handleInput}
                                        autocomplete="new-password"
                                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                        disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                    {/if}

                                    {#if column.type === 'number'}
                                    <input
                                        type="number"
                                        placeholder={column.label}
                                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                        bind:value={newEntity[column.key]}
                                        on:input={handleInput}
                                        disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                    {/if}

                                    {#if column.type === 'select' || column.type === 'json'}
                                        <select
                                            bind:value={newEntity[column.key]}
                                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                            on:blur={handleInput}
                                            disabled={!canModify && (!canCreate || currentEntityId)}
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {#each column.options as option}
                                                <option value={option.key}>{option.value}</option>
                                            {/each}
                                        </select>
                                    {/if}

                                    {#if column.type === 'date'}
                                    <DateInput
                                        bind:value={newEntity[column.key]}
                                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                        on:input={handleInput}
                                        placeholder="Selecciona una fecha"
                                        format="dd-MM-yyyy"
                                        disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                    {/if}

                                    {#if column.type === 'checkbox'}
                                        <div class="flex items-center">
                                            <input
                                                type="checkbox"
                                                bind:checked={newEntity[column.key]}
                                                id={column.key}
                                                class="mr-2"
                                                on:change={handleInput}
                                                disabled={!canModify && (!canCreate || currentEntityId) }
                                                />
                                            <label for={column.key} class="text-sm">{column.label}</label>
                                        </div>
                                    {/if}

                                    {#if column.type === 'file'}
                                    <div class="items-center">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            on:change={(e) => handleFileUpload(e, column.key)}
                                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                                            disabled={!canModify && (!canCreate || currentEntityId) }
                                        />
                                        {#if newEntity[column.key] && isPreviewReady}
                                        <img
                                            src={POCKETBASE_URL + '/api/files/' + newEntity['collectionId'] + '/' + newEntity['id'] + '/' + newEntity[column.key]}
                                            alt="Preview"
                                            class="mt-2 w-24 h-24 object-cover"
                                        />
                                        {/if}
                                    </div>
                                    {/if}

                                    {#if errors[column.key]}
                                    <p class="text-red-500 text-sm">{errors[column.key]}</p>
                                    {/if}
                                </div>
                            {/if}
                        {/each}
                    {/if}
                </div>
                <!-- Contenido de atributos -->
                {#if activeTab === 'atributos'}
                    <Atributos 
                        newEntity={newEntity} 
                        entityName={entityName} 
                        canModify={canModify}
                        canCreate={canCreate}
                        currentEntityId={currentEntityId}
                    />
                {/if}
                <!-- Contenido de impuestos -->
                {#if activeTab === 'impuestos'}
                    <Impuestos
                        newEntity={newEntity} 
                        entityName={entityName} 
                        canModify={canModify}
                        canCreate={canCreate}
                        currentEntityId={currentEntityId}
                    />
                {/if}
            </div>
            {#if canModify || canCreate}
                <button on:click={handleSave} class="mt-4 px-4 py-2 bg-blueGray-600 text-white rounded hover:bg-indigo-600">
                    {currentEntityId ? 'Actualizar' : 'Crear'}
                </button>
            {/if}
            <button on:click={togglePane} class="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">Cerrar</button>
        </div>
    </div>
{/if}
